import { Button, Col, Row, Container, Table, Tab } from 'react-bootstrap';
import toast, { Toaster } from "react-hot-toast";
import { useState, useEffect } from 'react';
import '../../css/common.css';
import '../../css/hover.css'
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { saveForm, deleteForm } from '../../store/Slices/formSlice';
import useValidation from '../../helpers/validation';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';

function Franceinternal() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userEmail = sessionStorage.getItem('email');


    useEffect(() => {
        const fetchData = async () => {
            if (!userEmail) {
                navigate('/');
                return;
            }
            const form = JSON.parse(localStorage.getItem('form'));

            if (form?.country?.country === 'France Internal') {
                fillForm(form);
            }
        };

        fetchData();
    }, [dispatch, navigate]);

    const { validateInput, validationStates, setValidationStates } = useValidation();

    const [phoneNumber, setPhoneNumber] = useState();
    const [isMainline, setIsMainline] = useState(false);
    //customer id
    const [companyName, setCompanyName] = useState();
    const [siretNumber, setSiretNumber] = useState();
    const [codeNaf, setCodeNaf] = useState();
    const [address, setAddress] = useState();
    const [locality, setLocality] = useState();
    const [postalCode, setPostalCode] = useState();
    //client id
    const [clientCompanyName, setClientCompanyName] = useState();
    const [clientSiretNumber, setClientSiretNumber] = useState();
    const [clientCodeNaf, setClientCodeNaf] = useState();
    const [clientAddress, setClientAddress] = useState();
    const [clientLocality, setClientLocality] = useState();
    const [clientPostalCode, setclientPostalCode] = useState();
    //porting contact
    const [contactName, setContactName] = useState();
    const [contactNumber, setContactNumber] = useState();
    const [contactEmail, setContactEmail] = useState();
    //-----------------------------------------------FillForm-------------------------------------------------//

    const fillForm = (form) => {
        //number id
        document.querySelector('#phoneNumber').value = form?.country?.number_identification?.idn ?? '';
        document.querySelector('#mainline').value = form?.country?.number_identification?.port_idn ?? '';
        setPhoneNumber(form?.country?.number_identification?.idn ?? '');
        setIsMainline(form?.country?.number_identification?.port_idn ?? '')

        setTableDataSingle(form?.country?.number_identification?.Single_Number ?? '');
        setTableDataRange(form?.country?.number_identification?.did_range ?? '');

        document.querySelector('#companyName').value = form?.country?.customer?.company_name ?? '';
        document.querySelector('#siretNumber').value = form?.country?.customer?.siret_number ?? '';
        document.querySelector('#codeNaf').value = form?.country?.customer?.code_naf ?? '';
        document.querySelector('#address').value = form?.country?.customer?.address ?? '';
        document.querySelector('#locality').value = form?.country?.customer?.locality ?? '';
        document.querySelector('#postalCode').value = form?.country?.customer?.postal_code ?? '';
        setCompanyName(form?.country?.customer?.company_name ?? '');
        setSiretNumber(form?.country?.customer?.siret_number ?? '');
        setCodeNaf(form?.country?.customer?.code_naf ?? '')
        setAddress(form?.country?.customer?.address ?? '')
        setLocality(form?.country?.customer?.locality ?? '')
        setPostalCode(form?.country?.customer?.postal_code ?? '')


        document.querySelector('#clientCompanyName').value = form?.country?.client?.company_name ?? '';
        document.querySelector('#clientSiretNumber').value = form?.country?.client?.siret_number ?? '';
        document.querySelector('#clientCodeNaf').value = form?.country?.client?.code_naf ?? '';
        document.querySelector('#clientAddress').value = form?.country?.client?.address ?? '';
        document.querySelector('#clientLocality').value = form?.country?.client?.locality ?? '';
        document.querySelector('#clientPostalCode').value = form?.country?.client?.postal_code ?? '';
        setClientCompanyName(form?.country?.client?.company_name ?? '');
        setClientSiretNumber(form?.country?.client?.siret_number ?? '');
        setClientCodeNaf(form?.country?.client?.code_naf ?? '')
        setClientAddress(form?.country?.client?.address ?? '')
        setClientLocality(form?.country?.client?.locality ?? '')
        setclientPostalCode(form?.country?.client?.postal_code ?? '')

        document.querySelector('#contactName').value = form?.country?.porting?.name ?? '';
        document.querySelector('#contactNumber').value = form?.country?.porting?.number ?? '';
        document.querySelector('#contactEmail').value = form?.country?.porting?.email ?? '';
        setContactName(form?.country?.porting?.name ?? '')
        setContactNumber(form?.country?.porting?.number ?? '')
        setContactEmail(form?.country?.porting?.email ?? '')



    }

    //-----------------------------------------------Hover-------------------------------------------------//

    const [hoveredField, setHoveredField] = useState(null); //hovered field

    const handleMouseEnter = (field) => {
        setHoveredField(field);
    };

    const handleMouseLeave = () => {
        setHoveredField(null);
    };

    //--------------------------------table declaration (Single)--------------------------------------//

    const [tableDataSingle, setTableDataSingle] = useState([{ id: Date.now(), num: '' }]);

    //adding a row
    const addRow_single = () => {
        setTableDataSingle([...tableDataSingle, { id: Date.now(), num: '' }]);
    };

    //removing a row
    const removeRow_single = (id) => {
        setTableDataSingle(tableDataSingle.filter(row => row.id !== id));
    };

    //change handler of table
    const handleChange_tableSingle = (id, key, value) => {
        const updatedData = tableDataSingle.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableDataSingle(updatedData);
    };

    //--------------------------------table declaration (DID Range)--------------------------------------//

    const [tableDataRange, setTableDataRange] = useState([{ id: Date.now(), sNumber: '', eNumber: '' }]);

    //adding a row
    const addRow_range = () => {
        setTableDataRange([...tableDataRange, { id: Date.now(), sNumber: '', eNumber: '' }]);
    };

    //removing a row
    const removeRow_range = (id) => {
        setTableDataRange(tableDataRange.filter(row => row.id !== id));
    };

    //change handler of table
    const handleChange_tableRange = (id, key, value) => {
        const updatedData = tableDataRange.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableDataRange(updatedData);
    };

    const fileInputRef = React.createRef();  // Create a reference to the file input element
    const [uploadedFileName, setUploadedFileName] = useState('');

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        // Display the file name
        setUploadedFileName(file.name);

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            // Read headers from row 5
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, range: 4 });
            if (!jsonData.length) {
                toast.error('Uploaded file is empty or has an invalid format.');
                setUploadedFileName('');
                return;
            }

            const fileHeaders = jsonData[0] || [];
            const expectedHeaders = ['Public from', 'Public to', 'Private from', 'Private to', 'Local Country Value'];

            // Check if headers match
            if (!expectedHeaders.every((header, index) => header === fileHeaders[index])) {
                toast.error('Uploaded file does not match the expected format.');
                setUploadedFileName('');
                return;
            }

            // Read actual data from row 6 onwards
            const dataRows = jsonData.slice(1);

            // Extract relevant data for tableDataRange (first two columns: start & end number)
            const formattedDataRange = dataRows.map((row, index) => ({
                id: index + 1,
                sNumber: row[0] ? row[0].toString() : '', // First column (start number)
                eNumber: row[1] ? row[1].toString() : '', // Second column (end number)
            }));

            // Set the table data for number range
            setTableDataRange(formattedDataRange);

            // Trigger validation for each row after setting data (similar to previous logic)
            formattedDataRange.forEach(row => {
                const startValue = row.sNumber;
                const endValue = row.eNumber;

                // Validate rangeStart (10-11 digits)
                if (startValue !== '' && !/^33\d{9}$/.test(startValue)) {
                    setValidationStates(prev => ({
                        ...prev,
                        [`startNumber-${row.id}`]: false,
                    }));
                } else {
                    setValidationStates(prev => ({
                        ...prev,
                        [`startNumber-${row.id}`]: true,
                    }));
                }

                // Validate rangeStop (10-11 digits)
                if (endValue !== '' && !/^33\d{9}$/.test(endValue)) {
                    setValidationStates(prev => ({
                        ...prev,
                        [`endNumber-${row.id}`]: false,
                    }));
                } else {
                    setValidationStates(prev => ({
                        ...prev,
                        [`endNumber-${row.id}`]: true,
                    }));
                }

                // Check if end range is greater than or equal to start range
                // if (startValue && endValue && parseInt(endValue, 10) < parseInt(startValue, 10)) {
                //     setValidationStates(prev => ({
                //         ...prev,
                //         [`startNumber-${row.id}`]: false,
                //         [`endNumber-${row.id}`]: false,
                //     }));
                // }

            });
        };
        reader.readAsArrayBuffer(file);
    };

    const removeUploadedFile = () => {
        // Clear the uploaded file name state
        setUploadedFileName('');

        // Reset the file input field value to clear the selected file
        fileInputRef.current.value = '';

        // Clear the table data by setting it to an empty array
        setTableDataRange([]);

        // Optionally clear the table data for 'Number Range' table
        setTableDataRange([]);
    };

    const handleDownload = async () => {
        try {
            // Fetch the file (portabilityImportTemplate.xlsx) from the server
            const response = await fetch(`/portabilityImportTemplate.xlsx?t=${new Date().getTime()}`);

            // Check if the response is valid
            if (!response.ok) throw new Error("Network response was not ok");

            // Convert the response to a Blob
            const blob = await response.blob();

            // Create a URL for the Blob to allow it to be downloaded
            const url = window.URL.createObjectURL(blob);

            // Create an anchor tag dynamically and trigger a click to download the file
            const a = document.createElement("a");
            a.href = url;
            a.download = "portabilityImportTemplate.xlsx"; // File name for download
            document.body.appendChild(a);
            a.click(); // Initiate the download
            document.body.removeChild(a); // Clean up by removing the anchor element
        } catch (error) {
            // Catch any error that occurs during the download process
            console.error("Download failed:", error);
        }
    };
    //-------------------------------------------creating Schema----------------------------------------//

    const json = {
        "country": {
            "country": "France Internal",
            "number_identification": {
                "idn": phoneNumber || "",
                "port_idn": isMainline,
                "Single_Number": tableDataSingle,
                "did_range": tableDataRange
            },
            "customer": {
                "company_name": companyName || "",
                "siret_number": siretNumber || "",
                "code_naf": codeNaf || "",
                "address": address || "",
                "locality": locality || "",
                "postal_code": postalCode || ""

            },
            "client": {
                "company_name": clientCompanyName || "",
                "siret_number": clientSiretNumber || "",
                "code_naf": clientCodeNaf || "",
                "address": clientAddress || "",
                "locality": clientLocality || "",
                "postal_code": clientPostalCode || ""
            },
            "porting": {
                "name": contactName || "",
                "number": contactNumber || "",
                "email": contactEmail || ""
            }
        },
        "email": sessionStorage.getItem('email'),
    };

    const jsonString = JSON.stringify(json);

    //console.log(jsonString);

    //-----------------------------------------sending request---------------------------------------------//

    async function Submit(e) {

        let validationErrors = {};
        if (!phoneNumber) {
            validationErrors.phoneNumber = 'Please fill in the IDN number.';
        }
        //customer
        if (!companyName) {
            validationErrors.companyName = 'please fill in Company Name';
        }
        if (!siretNumber) {
            validationErrors.siretNumber = 'Please fill in the siret number.';
        }
        if (!address) {
            validationErrors.address = 'Please fill in the address.';
        }
        if (!locality) {
            validationErrors.locality = 'Please fill in the locality.';
        }
        if (!postalCode) {
            validationErrors.postalCode = 'Please fill in the postal code.';
        }
        //client
        if (!clientCompanyName) {
            validationErrors.clientCompanyName = 'Please fill in the client comapny name.';
        }
        if (!clientSiretNumber) {
            validationErrors.clientSiretNumber = 'Please fill in the client siret number.';
        }
        if (!clientAddress) {
            validationErrors.clientAddress = 'Please fill in the client address.';
        }
        if (!clientLocality) {
            validationErrors.clientLocality = 'Please fill in the client locality.';
        }
        if (!clientPostalCode) {
            validationErrors.clientPostalCode = 'Please fill in the client postal code.';
        }
        //porting
        if (!contactName) {
            validationErrors.contactName = 'Please fill in the Contact Name in Contact Details'
        }
        if (!contactNumber) {
            validationErrors.contactNumber = 'Please fill in the Contact Number in Contact Details'
        }
        if (!contactEmail) {
            validationErrors.contactEmail = 'Please fill in the Contact Email in Contact Details'
        }

        const hasValidationError = Object.values(validationErrors).length > 0;

        if (hasValidationError) {
            // Update validation states
            setValidationStates(prevState => ({
                ...prevState,
                ...Object.keys(validationErrors).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {})
            }));

            //Show the first error message
            const firstError = Object.values(validationErrors)[0];
            const firstErrorKey = Object.keys(validationErrors)[0];
            document.getElementById(firstErrorKey).scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(firstError);
            return;

        }

        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => value === false)
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            toast.error(`Please make sure fields in red are correct. \n${falseKeys} `);
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            return;
        }
        // If all validations pass, proceed with the form submission
        e.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/generate_loa`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: jsonString
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blobData = await response.blob();
            const url = URL.createObjectURL(blobData);
            const a = document.createElement('a');
            a.href = url;
            a.download = companyName + '-LOA.docx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading file: ', error);
            // toast.error("An error occurred while processing your request.");
            window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home'
        }
    }

    //----------------------------------------------RESET--------------------------------------------------//

    async function Reset(e) {
        const dataToBeDeleted = { "email": userEmail };
        dispatch(deleteForm(dataToBeDeleted));
        localStorage.removeItem('form');
        window.location.reload();
    }

    async function save(e) {
        e.preventDefault();
        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => {
                const element = document.getElementById(key);
                return value === false && element && element.value.trim() !== '';
            })
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(`Please make sure following fields in red are correct before saving `);
            return;
        }

        localStorage.setItem('form', JSON.stringify(json));
        const dataToBeSaved = { "email": userEmail, "json_data": json };
        try {
            const response = await dispatch(saveForm(dataToBeSaved));
            if (response?.payload?.message === "success") {
                toast.success('Form saved successfully');
            }
        } catch (error) {
            toast.error('There was an error processing your request.');
        }
    }

    //-----------------------------------------------JSX----------------------------------------------------//

    return (
        <div>

            <Toaster position="top-center" reverseOrder={false}></Toaster>

            <div className='french'>

                {/* starting para */}
                <Container>
                    <p><strong>Mandatory fields are marked by *</strong></p> <br></br>

                    <p>This document must be used exclusively in the context of:<br></br>&emsp; A request to transfer an existing Orange SA product to the Business Talk product.<br></br>&emsp; A transfer of Business Talk numbers to a new customer.<br></br>This document must not be used in the event of Portability between a third party operator and Orange SA.<br></br><br></br>This document must be attached when requesting portability.</p>
                </Container>
                <br></br><br></br>
                {/* identification of numbers */}
                <Container>

                    <h2 className='heading'>Identification of numbers </h2> <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('phoneNumber')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>IDN*</label> <br />
                            <input
                                onChange={(e) => setPhoneNumber(e.target.value)}
                                type="text"
                                id='phoneNumber'
                                placeholder=""
                                className={`inputbox ${validationStates.phoneNumber === false ? 'error' : ''}`}
                                onBlur={() => validateInput('phoneNumber', /^33\d{9}$/)}
                            />
                            {hoveredField === 'phoneNumber' && (
                                <div className="hover-description">
                                    Enter IDN (installation designation number)
                                </div>
                            )}
                        </Col>
                    </Row>
                    <br></br>
                    <Row>
                        <Col>
                            <div>
                                <input
                                    type="checkbox"
                                    id="mainline"
                                    name="mainline"
                                    checked={isMainline} // Bind state to checked attribute
                                    onChange={(e) => setIsMainline(e.target.checked)} // Handle checkbox change                
                                />
                                <label htmlFor="mainline">&nbsp; IDN to be ported</label>
                            </div>
                        </Col>
                    </Row>
                    <br></br>
                    <Row>
                        <Container>
                            <h4 className='text-decoration-underline'>Single Number</h4> <br></br>

                            <Table striped bordered hover variant="light">
                                <thead>
                                    <tr>
                                        <th>Number</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {tableDataSingle.map(row => (
                                        <tr key={row.id}>

                                            <td
                                                onMouseEnter={() => handleMouseEnter(`number-${row.id}`)}
                                                onMouseLeave={handleMouseLeave}
                                            >
                                                <input
                                                    type="text"
                                                    id={`number-${row.id}`}
                                                    value={row.num}
                                                    onChange={(e) => {
                                                        const value = e.target.value;

                                                        // Update the state with the input value
                                                        handleChange_tableSingle(row.id, 'num', value);

                                                        // Immediate validation feedback for 11 digits only when not empty
                                                        if (value !== '' && !/^33\d{9}$/.test(value)) {
                                                            setValidationStates(prev => ({
                                                                ...prev,
                                                                [`number-${row.id}`]: false,
                                                            }));
                                                        } else {
                                                            setValidationStates(prev => ({
                                                                ...prev,
                                                                [`number-${row.id}`]: true,
                                                            }));
                                                        }
                                                    }}
                                                    className={`inputbox ${validationStates[`number-${row.id}`] === false && row.num !== '' ? 'error' : ''}`}
                                                    onBlur={() => {
                                                        // Final validation check on blur for 10 digits only when not empty
                                                        if (row.num !== '' && !/^33\d{9}$/.test(row.num)) {
                                                            toast.error('Number must be exactly 11 digits and start with 33.');
                                                            setValidationStates(prev => ({
                                                                ...prev,
                                                                [`number-${row.id}`]: false,
                                                            }));
                                                        }
                                                    }}
                                                />
                                                {hoveredField === `number-${row.id}` && (
                                                    <div className="hover-description">
                                                        Enter the single numbers if it exists.
                                                    </div>
                                                )}
                                                {validationStates[`number-${row.id}`] === false && row.num !== '' && (
                                                    <div className="error-message">
                                                        Number must be exactly 11 digits and start with 33.
                                                    </div>
                                                )}
                                            </td>

                                            <td>
                                                {tableDataSingle.length > 1 && (
                                                    <button onClick={() => removeRow_single(row.id)}>Remove</button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}

                                </tbody>
                            </Table>

                            <button onClick={addRow_single}>Add Row</button>

                            <br />

                        </Container>
                        <br></br><br></br>
                        <Container>
                            <br></br>
                            <h4 className='text-decoration-underline'>DID Range</h4> <br></br>

                            <Row>
                                <Col>
                                    <button
                                        variant="secondary"
                                        className="inputbox"
                                        style={{ alignItems: 'center' }}
                                        onClick={() => fileInputRef.current.click()}
                                    >
                                        <FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px' }} />
                                        Upload File
                                    </button>
                                    <input
                                        id="fileUploadInput"
                                        type="file"
                                        accept=".xlsx, .xls"
                                        onChange={handleFileUpload}
                                        ref={fileInputRef}
                                        style={{ display: 'none' }}
                                    />
                                </Col>

                                <Col>
                                    <button className="inputbox" onClick={handleDownload} style={{ alignItems: 'center' }}>
                                        <FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px' }} />
                                        Download number range template
                                    </button>
                                </Col>

                                <Col>
                                    {uploadedFileName && (
                                        <button onClick={removeUploadedFile} className="inputbox" style={{ alignItems: 'center' }}>
                                            <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                            Remove
                                        </button>
                                    )}
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    {uploadedFileName && (
                                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                            <p style={{ marginRight: '10px' }}>Uploaded File: {uploadedFileName}</p>
                                        </div>
                                    )}
                                </Col>
                            </Row>

                            <br />
                            <p>The template is the same used for the btd portability request.</p>
                            <br />

                            <br></br>

                            <Table striped bordered hover variant="light">
                                <thead>
                                    <tr>
                                        <th>DID first number in range</th>
                                        <th>DID last number in range</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {tableDataRange.map(row => (
                                        <tr key={row.id}>

                                            <td
                                                onMouseEnter={() => handleMouseEnter(`startNumber-${row.id}`)}
                                                onMouseLeave={handleMouseLeave}
                                            >
                                                <input
                                                    type="text"
                                                    id={`startNumber-${row.id}`} // Corrected ID for num input
                                                    value={row.sNumber}
                                                    onChange={(e) => {
                                                        const value = e.target.value;

                                                        // Update the state with the input value
                                                        handleChange_tableRange(row.id, 'sNumber', value);

                                                        // Immediate validation feedback for 10 digits
                                                        if (value !== '' && !/^33\d{9}$/.test(value)) {
                                                            setValidationStates(prev => ({
                                                                ...prev,
                                                                [`startNumber-${row.id}`]: false,
                                                            }));
                                                        } else {
                                                            setValidationStates(prev => ({
                                                                ...prev,
                                                                [`startNumber-${row.id}`]: true,
                                                            }));
                                                        }

                                                    }}
                                                    className={`inputbox ${validationStates[`startNumber-${row.id}`] === false && row.sNumber !== '' ? 'error' : ''}`}
                                                    onBlur={() => {
                                                        // Final validation check on blur for 10 digits
                                                        if (row.sNumber && !/^33\d{9}$/.test(row.sNumber)) { // Only validate if value is not empty
                                                            toast.error('Number must be exactly 11 digits and start with 33.');
                                                            setValidationStates(prev => ({
                                                                ...prev,
                                                                [`startNumber-${row.id}`]: false,
                                                            }));
                                                        }
                                                    }}
                                                />
                                                {hoveredField === `startNumber-${row.id}` && (
                                                    <div className="hover-description">
                                                        Enter the start of number range
                                                    </div>
                                                )}
                                            </td>

                                            <td
                                                onMouseEnter={() => handleMouseEnter(`endNumber-${row.id}`)}
                                                onMouseLeave={handleMouseLeave}
                                            >
                                                <input
                                                    type="text"
                                                    id={`endNumber-${row.id}`} // Corrected ID for num input
                                                    value={row.eNumber}
                                                    onChange={(e) => {
                                                        const value = e.target.value;

                                                        // Update the state with the input value
                                                        handleChange_tableRange(row.id, 'eNumber', value);

                                                        // Immediate validation feedback for 10 digits
                                                        if (value && !/^33\d{9}$/.test(value)) { // Only validate if value is not empty
                                                            setValidationStates(prev => ({
                                                                ...prev,
                                                                [`endNumber-${row.id}`]: false,
                                                            }));
                                                        } else {
                                                            setValidationStates(prev => ({
                                                                ...prev,
                                                                [`endNumber-${row.id}`]: true,
                                                            }));
                                                        }
                                                    }}
                                                    className={`inputbox ${validationStates[`endNumber-${row.id}`] === false ? 'error' : ''}`}
                                                    onBlur={() => {
                                                        // Final validation check on blur for 10 digits
                                                        if (row.eNumber && !/^33\d{9}$/.test(row.eNumber)) { // Only validate if value is not empty
                                                            toast.error('Number must be exactly 11 digits and start with 33.');
                                                            setValidationStates(prev => ({
                                                                ...prev,
                                                                [`endNumber-${row.id}`]: false,
                                                            }));
                                                        }
                                                    }}
                                                />
                                                {hoveredField === `endNumber-${row.id}` && (
                                                    <div className="hover-description">
                                                        Enter the end of the number range
                                                    </div>
                                                )}
                                            </td>


                                            <td>
                                                {tableDataRange.length > 1 && (
                                                    <button onClick={() => removeRow_range(row.id)}>Remove</button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}

                                </tbody>
                            </Table>

                            <button onClick={addRow_range}>Add Row</button>

                            <br />

                        </Container>
                    </Row>

                    <br />

                </Container>
                <br></br>
                {/* customer identification */}
                <Container>

                    <h2 className='heading'>Identification of the customer holding the number(s)</h2> <br></br>

                    <Row>
                        {/* company name */}
                        <Col
                            onMouseEnter={() => handleMouseEnter('companyName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Company Name*</label> <br />
                            <input
                                onChange={(e) => setCompanyName(e.target.value)}
                                type="text"
                                id="companyName"
                                placeholder=""
                                className={`inputbox ${validationStates.companyName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('companyName', /^[a-zA-Z0-9\s\W]+$/)}

                            />
                            {hoveredField === 'companyName' && (
                                <div className="hover-description">
                                    Enter the customer's company name
                                </div>
                            )}
                        </Col>
                        {/* siret number */}
                        <Col
                            onMouseEnter={() => handleMouseEnter('siretNumber')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>SIRET number ( SIREN + NIC)*</label> <br />
                            <input
                                onChange={(e) => setSiretNumber(e.target.value)}
                                type="text"
                                id="siretNumber"
                                placeholder=""
                                className={`inputbox ${validationStates.siretNumber === false ? 'error' : ''}`}
                                onBlur={() => validateInput('siretNumber', /^\d{14}$/)}
                            />
                            {hoveredField === 'siretNumber' && (
                                <div className="hover-description">
                                    Enter the customer's siret number siren nic
                                </div>
                            )}
                        </Col>
                        {/* code naf */}
                        <Col
                            onMouseEnter={() => handleMouseEnter('codeNaf')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Code NAF</label> <br />
                            <input
                                onChange={(e) => setCodeNaf(e.target.value)}
                                type="text"
                                id="codeNaf"
                                placeholder=""
                                className={`inputbox`}
                            />
                            {hoveredField === 'codeNaf' && (
                                <div className="hover-description">
                                    Enter the customer's code NAF
                                </div>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        {/* address */}
                        <Col
                            onMouseEnter={() => handleMouseEnter('address')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Address*</label> <br />
                            <input
                                id="address" // Unique ID
                                type="text"
                                name="address"
                                // value={section.address}
                                onChange={(e) => setAddress(e.target.value)}
                                className={`inputbox ${validationStates.address === false ? 'error' : ''}`}
                                onBlur={() => validateInput(`address`, /^[a-zA-Z0-9\s\W]+$/)}
                            />
                            {hoveredField === `address` && (
                                <div className="hover-description">
                                    Enter the customer's address
                                </div>
                            )}
                        </Col>
                        {/* locality */}
                        <Col
                            onMouseEnter={() => handleMouseEnter(`locality`)}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Locality*</label> <br />
                            <input
                                id="locality" // Unique ID
                                type="text"
                                name="locality"
                                // value={section.locality}
                                onChange={(e) => setLocality(e.target.value)}
                                className={`inputbox ${validationStates.locality === false ? 'error' : ''}`}
                                onBlur={() => validateInput(`locality`, /^[\w\W,]+$/)}
                            />
                            {hoveredField === `locality` && (
                                <div className="hover-description">
                                    Enter the customer's locality
                                </div>
                            )}
                        </Col>
                        {/* postal code */}
                        <Col
                            onMouseEnter={() => handleMouseEnter(`postalCode`)}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Postal Code*</label> <br />
                            <input
                                id='postalCode' // Unique ID
                                type="text"
                                name="postalCode"
                                // value={section.postalCode}
                                onChange={(e) => setPostalCode(e.target.value)}
                                className={`inputbox ${validationStates.postalCode === false ? 'error' : ''}`}
                                onBlur={() => validateInput(`postalCode`, /^\d{5}$/)}
                            />
                            {hoveredField === `postalCode` && (
                                <div className="hover-description">
                                    Enter the customer's postal code
                                </div>
                            )}
                        </Col>
                        <Row></Row>
                        <br></br>
                    </Row>

                    <br />

                </Container>
                <br></br>
                {/* client side identification */}
                <Container>

                    <h2 className='heading'>Client Site Identification</h2> <br></br>

                    <Row>
                        {/* client company name */}
                        <Col
                            onMouseEnter={() => handleMouseEnter('clientCompanyName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Company Name*</label> <br />
                            <input
                                onChange={(e) => setClientCompanyName(e.target.value)}
                                type="text"
                                id="clientCompanyName"
                                placeholder=""
                                className={`inputbox ${validationStates.clientCompanyName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('clientCompanyName', /^[a-zA-Z0-9\s\W]+$/)}

                            />
                            {hoveredField === 'clientCompanyName' && (
                                <div className="hover-description">
                                    Enter the site's company name
                                </div>
                            )}
                        </Col>
                        {/* client siret number */}
                        <Col
                            onMouseEnter={() => handleMouseEnter('clientSiretNumber')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>SIRET number ( SIREN + NIC)*</label> <br />
                            <input
                                onChange={(e) => setClientSiretNumber(e.target.value)}
                                type="text"
                                id="clientSiretNumber"
                                placeholder=""
                                className={`inputbox ${validationStates.clientSiretNumber === false ? 'error' : ''}`}
                                onBlur={() => validateInput('clientSiretNumber', /^\d{14}$/)}
                            />
                            {hoveredField === 'clientSiretNumber' && (
                                <div className="hover-description">
                                    Enter the site's siret number siren nic
                                </div>
                            )}
                        </Col>
                        {/* client code naf */}
                        <Col
                            onMouseEnter={() => handleMouseEnter('clientCodeNaf')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Code NAF</label> <br />
                            <input
                                onChange={(e) => setClientCodeNaf(e.target.value)}
                                type="text"
                                id="clientCodeNaf"
                                placeholder=""
                                className={`inputbox`}
                            />
                            {hoveredField === 'clientCodeNaf' && (
                                <div className="hover-description">
                                    Enter the site's code NAF
                                </div>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        {/* client address */}
                        <Col
                            onMouseEnter={() => handleMouseEnter('clientAddress')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Address*</label> <br />
                            <input
                                id="clientAddress" // Unique ID
                                type="text"
                                name="address"
                                // value={section.address}
                                onChange={(e) => setClientAddress(e.target.value)}
                                className={`inputbox ${validationStates.clientAddress === false ? 'error' : ''}`}
                                onBlur={() => validateInput(`clientAddress`, /^[a-zA-Z0-9\s\W]+$/)}
                            />
                            {hoveredField === `clientAddress` && (
                                <div className="hover-description">
                                    Enter the site's address
                                </div>
                            )}
                        </Col>
                        {/* client locality */}
                        <Col
                            onMouseEnter={() => handleMouseEnter(`clientLocality`)}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Locality*</label> <br />
                            <input
                                id="clientLocality" // Unique ID
                                type="text"
                                name="locality"
                                // value={section.locality}
                                onChange={(e) => setClientLocality(e.target.value)}
                                className={`inputbox ${validationStates.clientLocality === false ? 'error' : ''}`}
                                onBlur={() => validateInput(`clientLocality`, /^[\w\W,]+$/)}
                            />
                            {hoveredField === `clientLocality` && (
                                <div className="hover-description">
                                    Enter the site's locality
                                </div>
                            )}
                        </Col>
                        {/* client postal code */}
                        <Col
                            onMouseEnter={() => handleMouseEnter(`clientPostalCode`)}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Postal Code*</label> <br />
                            <input
                                id='clientPostalCode' // Unique ID
                                type="text"
                                name="postalCode"
                                // value={section.postalCode}
                                onChange={(e) => setclientPostalCode(e.target.value)}
                                className={`inputbox ${validationStates.clientPostalCode === false ? 'error' : ''}`}
                                onBlur={() => validateInput(`clientPostalCode`, /^\d{5}$/)}
                            />
                            {hoveredField === `clientPostalCode` && (
                                <div className="hover-description">
                                    Enter the customer's postal code
                                </div>
                            )}
                        </Col>
                        <Row></Row>
                        <br></br>
                    </Row>

                    <br />

                </Container>
                <br></br>
                {/* porting contacts */}
                <Container>

                    <h2 className='heading'>Contact Details</h2> <br></br>

                    <Row>
                        {/* porting contact name */}
                        <Col
                            onMouseEnter={() => handleMouseEnter('contactName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Contact Name*</label> <br />
                            <input
                                onChange={(e) => setContactName(e.target.value)}
                                type="text"
                                id="contactName"
                                placeholder=""
                                className={`inputbox ${validationStates.contactName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('contactName', /^[a-zA-Z0-9\s\W]+$/)}

                            />
                            {hoveredField === 'contactName' && (
                                <div className="hover-description">
                                    Enter the Contact name for site porting.
                                </div>
                            )}
                        </Col>
                        {/* porting contact number */}
                        <Col
                            onMouseEnter={() => handleMouseEnter('contactNumber')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Contact Number*</label> <br />
                            <input
                                onChange={(e) => setContactNumber(e.target.value)}
                                type="text"
                                id="contactNumber"
                                placeholder=""
                                className={`inputbox ${validationStates.contactNumber === false ? 'error' : ''}`}
                                onBlur={() => validateInput('contactNumber', /^\d+$/)}
                            />
                            {hoveredField === 'contactNumber' && (
                                <div className="hover-description">
                                    Enter the Contact Number for site porting
                                </div>
                            )}
                        </Col>
                        {/* porting contact email */}
                        <Col
                            onMouseEnter={() => handleMouseEnter('contactEmail')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Contact Email*</label> <br />
                            <input
                                onChange={(e) => setContactEmail(e.target.value)}
                                type="text"
                                id='contactEmail'
                                placeholder=""
                                className={`inputbox ${validationStates.contactEmail === false ? 'error' : ''}`}
                                onBlur={() => validateInput('contactEmail', /^[\w\W,]+$/)}
                            />
                            {hoveredField === 'contactEmail' && (
                                <div className="hover-description">
                                    Enter your Email in Porting Details
                                </div>
                            )}
                        </Col>

                    </Row>
                    <br />

                </Container>


                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="primary" type="save" onClick={save}>Save</Button>
                    <Button variant="primary" type="submit" onClick={Submit}>Generate LOA</Button>
                    <Button variant="primary" type="reset" onClick={Reset} style={{ marginRight: '20px' }}>Reset</Button>
                </div>
            </div>

        </div>
    );
}

export default Franceinternal;